import React from 'react';
import './style.scss';

type BadgeNewContentProps = {
    className?: string;
    position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
    text?: string;
};

const BadgeNewContent = ({
    className = '',
    position = 'top-left',
    text = 'Novos conteúdos',
}: BadgeNewContentProps) => {
    return <span className={`badgeNewContent content ${position} ${className}`.trim()}>{text}</span>;
};

export default BadgeNewContent;
